import { apiRequest } from "../utils/apiClient";

export const SUCCESS_MESSAGE =
  "Thank you. Your submission has been sent for admin approval.";

export function isPendingStatus(status) {
  return String(status || "pending").toLowerCase() === "pending";
}

export function isApprovedStatus(status) {
  return String(status || "").toLowerCase() === "approved";
}

export function isRejectedStatus(status) {
  return String(status || "").toLowerCase() === "rejected";
}

export function submitInsight(formData) {
  return apiRequest("post", "/api/insights/upload", {
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function fetchMyInsights() {
  return apiRequest("get", "/api/insights/mine");
}

export function fetchPendingInsights() {
  return apiRequest("get", "/api/insights/pending");
}

export function fetchAllInsights() {
  return apiRequest("get", "/api/insights/all");
}

export function fetchAuthUsers() {
  return apiRequest("get", "/api/auth/users");
}

export function fetchInsightById(id) {
  return apiRequest("get", `/api/insights/${id}`);
}

export function updateInsightStatus(id, status) {
  return apiRequest("put", `/api/insights/approve/${id}`, { data: { status } });
}

export function deleteInsight(id) {
  return apiRequest("delete", `/api/insights/${id}`);
}
